import { render } from "./MeetingTypesView.vue?vue&type=template&id=afd19768"
import script from "./MeetingTypesView.vue?vue&type=script&lang=js"
export * from "./MeetingTypesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__